import React from "react";
import {
  HashRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

// Services
import { authService } from "../Services/auth.service";

// Pages
import Login from "../Pages/Login/Login";
import Layout from "../Pages/Layouts/Layout";
import Home from "../Pages/Home/Home";
import RegisterVehicle from "../Pages/Vehicles/RegisterVehicle";
import ManufacturersLegacy from "../Pages/Vehicles/ManufacturersLegacy";
import Manufacturers from "../Pages/Vehicles/Manufacturers";
import Models from "../Pages/Vehicles/Models";
import Categories from "../Pages/Vehicles/Categories";
import Colors from "../Pages/Vehicles/Colors";
import FetcherTest from "../Pages/Mocks/fetcher";
import Chips from "../Pages/Equipments/Chips";
import Suppliers from "../Pages/Equipments/Suppliers";
import Networks from "../Pages/Equipments/Networks";
import Equipments from "../Pages/Equipments/Equipments";
import EquipmentsModels from "../Pages/EquipmentsModels/EquipmentsModels.jsx";
import EquipmentModelCommands from "../Pages/EquipmentsModels/EquipmentModelCommands";
import EquipmentCommandAccessLevels from "../Pages/EquipmentsModels/EquipmentCommandAccessLevels";
import ClientSearch from "../Pages/Clients/ClientSearch";
import ClientDetails from "../Pages/Clients/ClientDetails";
import Imports from "../Pages/Imports/Imports";
import Fleet from "../Pages/Tracking/Fleet";
import OperationalDetails from "../Pages/Indicators/OperationalDetails";
import MessageDetails from "../Pages/Indicators/MessageDetails";
import MaintenanceDetails from "../Pages/Indicators/MaintenanceDetails";
import ViewMapFilters from "../Pages/Tracking/ViewMap/ViewMapFilters";
import ViewMap from "../Pages/Tracking/ViewMap/ViewMap";
import ControlPoints from "../Pages/Control/ControlPoints";
import VisitPoints from "../Pages/Control/VisitPoints";
import LogsControl from "../Pages/Control/LogsControl";
import Checklist from "../Pages/Checklist/Checklist";
import ReportPage from "../Pages/Reports/ReportPage";
import AlertsPage from "../Pages/Alerts/AlertsPage";
import ProtocolsPage from "../Pages/Protocols/ProtocolsPage";
import ProtocolSummaryPage from "../Pages/Protocols/ProtocolSummaryPage";
import ReportVehicleActivity from '../Pages/Reports/ReportVehicleActivity';
import { reportService } from "../Services/report.service";
import WorkingInProgress from "../Pages/WorkingInProgress/WorkingInProgress";
import Profile from "../Pages/Reports/Profile/Profile";
import TableSyncExample from "../Pages/Reports/tableExample/TableSyncExample";
import ClientUsers from "../Pages/ClientUsers/ClientUsers";
import VehicleNearest from "../Pages/Vehicles/Nearby/VehicleNearest";
import Groups from "../Pages/Vehicles/Groups";
import VehiclesNickame from "../Pages/Vehicles/VehiclesNickame";
import VehiclesStatus from "../Pages/Vehicles/VehiclesStatus";
import VehiclesConfig from "../Pages/Vehicles/VehiclesConfig";
import { EletronicFences } from "../Pages/Control/EletronicFences";
import RiskArea from "../Pages/Control/RiskArea";
import DriverList from "../Pages/Driver/DriverList";
import { LinkedVehicles } from "../Pages/Vehicles/LinkedVehicles";
import { GroupUsers } from "../Pages/Groups/GroupUsers";
import { ItensMaintenances } from "../Pages/Maintenances/ItensMaintenances";
import { SchedulingMaintenances } from "../Pages/Maintenances/SchedulingMaintenances";
import { RegisterOdometer } from "../Pages/Maintenances/RegisterOdometer";
import { MaintenancesPendings } from "../Pages/Maintenances/MaintenancesPendings";
import { MaintenanceCompleted } from "../Pages/Maintenances/MaintenanceCompleted";
import { ShippingItems } from "../Pages/Maintenances/ShippingItems";
import PolygonFences from "../Pages/Control/PolygonFences";
import CreateLicensed from "../Pages/Previews/pages/CreateLicensed";
import ValidateEmail from "../Pages/ValidateEmail/ValidateEmail";
import CustomerServicePage from "../Pages/CustomerServicePage";
import Fuels from "../Fuels/Fuels";
import SummaryVehicles from "../Pages/Reports/SummaryVehicles";
import RoutingScreen from "../Pages/Routing/Routing";
import RoutesList from "../Pages/Routing/RoutesList";
import FretamentoClients from "../Pages/Fretamento/Clients";
import FretamentoPaths from "../Pages/Fretamento/Paths";
import NotificationsConfig from "../Pages/Notifications/NotificationsConfig";
import AccessProfile from "../Pages/AccessProfile/AccessProfile";
import UserPermissions from "../Pages/AccessProfile/UserPermissions";
import CustomerMain from "../Pages/Customer/main";

export default function Routing() {
  return (
    <HashRouter>
      <Routes>
        <Route index element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="resetpass/:keypass" element={<Login />} />
        <Route path="/validate-email" element={<ValidateEmail />} />
        <Route
          path="/"
          element={
            <RequireAuthAndDomain>
              <Layout />
            </RequireAuthAndDomain>
          }
        >
          <Route path="home" element={<Home />} />
          <Route path="client-users" element={<ClientUsers />} />
          <Route path="vehicle" element={<RegisterVehicle />} />
          <Route path="groups" element={<Groups />} />
          <Route path="manufacturer" element={<ManufacturersLegacy />} />
          <Route path="equipment-makers" element={<Manufacturers />} />
          <Route path="equipment-models" element={<EquipmentsModels />} />
          <Route path="equipment-models-commands" element={<EquipmentModelCommands />} />
          <Route path="equipment-models-access-levels" element={<EquipmentCommandAccessLevels />} />
          <Route path="models" element={<Models />} />
          <Route path="categories" element={<Categories />} />
          <Route path="colors" element={<Colors />} />
          <Route path="chips" element={<Chips />} />
          <Route path="suppliers" element={<Suppliers />} />
          <Route path="networks" element={<Networks />} />
          <Route path="equipments" element={<Equipments />} />
          <Route path="clients" element={<ClientSearch />} />
          <Route path="clients/details/:id" element={<ClientDetails />} />
          <Route path="fetch" element={<FetcherTest />} />
          <Route path="imports" element={<Imports />} />
          <Route path="fleet" element={<Fleet />} />
          <Route path="checkout" element={<Checklist />} />
          <Route path="operationaldetails" element={<OperationalDetails />} />
          <Route path="messagedetails" element={<MessageDetails />} />
          <Route path="maintenancedetails" element={<MaintenanceDetails />} />
          <Route path="mapfilters" element={<ViewMapFilters />} />
          {/* #317: /routing agora abre a listagem; a tela de roteirização
              (formulário atual) fica em /routing/new, acessada pelo botão
              "Roteirizar" dentro da listagem. */}
          <Route path="routing" element={<RoutesList />} />
          <Route path="routing/new" element={<RoutingScreen />} />
          <Route path="profile" element={<Profile />} />
          <Route path="tableSync" element={<TableSyncExample />} />
          <Route path="vehicles/nearby" element={<VehicleNearest />} />
          <Route path="vehicles/nickname" element={<VehiclesNickame />} />
          <Route path="vehicles/status/:code" element={<VehiclesStatus />} />
          <Route path="vehicles/configuration" element={<VehiclesConfig />} />
          <Route path="visitpoint" element={<VisitPoints />} />
          <Route path="controlpoint" element={<ControlPoints />} />
          <Route path="logcontrol" element={<LogsControl />} />
          <Route path="electric-fence" element={<EletronicFences />} />
          <Route path="electric-fence/edit/:id" element={<EletronicFences />} />
          <Route path="risk-area" element={<RiskArea />} />
          <Route path="polygon-fences" element={<PolygonFences />} />
          <Route path="driver" element={<DriverList />} />
          <Route path="linked-vehicles" element={<LinkedVehicles />} />
          <Route path="group-users" element={<GroupUsers />} />
          <Route path="vehicle-activity-report" element={<ReportVehicleActivity />} />
          <Route path="maintenances/items" element={<ItensMaintenances />} />
          <Route path="maintenances/scheduling" element={<SchedulingMaintenances />} />
          <Route path="maintenances/register" element={<RegisterOdometer />} />
          <Route path="maintenances/pendings" element={<MaintenancesPendings />} />
          <Route path="maintenances/completed" element={<MaintenanceCompleted />} />
          <Route path="maintenances/shipping" element={<ShippingItems />} />
          <Route path="licenseds" element={<CreateLicensed />} />
          <Route path="localization" element={<CustomerServicePage />} />
          <Route path="fuels" element={<Fuels />} />
          <Route path="summary-vehicles" element={<SummaryVehicles />} />
          <Route path="chartering/clients" element={<FretamentoClients />} />
          <Route path="chartering/paths" element={<FretamentoPaths />} />
          <Route path="notifications-config" element={<NotificationsConfig />} />
          <Route path="access-profile" element={<AccessProfile />} />
          <Route path="user-permissions" element={<UserPermissions />} />
          <Route path="customers" element={<CustomerMain />} />

          {/* Relatórios */}
          <Route
            path="/journeywork"
            element={
              <ReportPage
                pageTitle="Deslocamento"
                pageGrid={"gridJourneyWork"}
                reportServiceFunction={reportService.fetchJourneyWork}
              />
            }
          />
          <Route
            path="/travelleddistance"
            element={
              <ReportPage
                pageTitle="Distância Percorrida"
                pageGrid={"gridTravelledDistance"}
                reportServiceFunction={reportService.fetchDistanceTravelled}
              />
            }
          />
          <Route
            path="/vehicleactivities"
            element={
              <ReportPage
                pageGrid={"gridVehicleActivities"}
                pageTitle="Controle de Uso"
                reportServiceFunction={reportService.fetchVehicleActivities}
              />
            }
          />
          <Route
            path="/vehiclepositions"
            element={
              <ReportPage
                pageGrid={"gridVehiclePositions"}
                pageTitle="Posicionamento"
                reportServiceFunction={async (payload, download) => {
                  const positionsPayload = {
                    VehicleId: payload?.vehicleId,
                    GroupId: payload?.groupId,
                    StartDate: payload?.dateTimeScheduleStart,
                    EndDate: payload?.dateTimeScheduleEnd,
                    OnlyEvents: payload?.onlyEvents ?? payload?.OnlyEvents ?? "N",
                    SplitByPlateSheets:
                      payload?.splitByPlateSheets ??
                      payload?.SplitByPlateSheets ??
                      false,
                  };
                  if (!download) {
                    return reportService.fetchVehiclesPositionsPaged({
                      ...positionsPayload,
                    });
                  }
                  const normalizedType = (payload?.fileType || "").toLowerCase();
                  if (normalizedType === "pdf") return reportService.fetchVehiclesPositionsPdf(positionsPayload);
                  if (normalizedType === "xls" || normalizedType === "xlsx") return reportService.fetchVehiclesPositionsXls(positionsPayload);
                  if (normalizedType === "kmz") return reportService.fetchVehiclesPositionsKmz(positionsPayload);
                  return null;
                }}
              />
            }
          />
          <Route
            path="/vehiclevisits"
            element={
              <ReportPage
                pageGrid={"gridPeriodVisits"}
                pageTitle="Veículos em visitas"
                reportServiceFunction={reportService.fetchVisitsInPeriod}
              />
            }
          />
          <Route
            path="/visitsvehicle"
            element={
              <ReportPage
                pageGrid={"gridVisitAmount"}
                pageTitle="Veículos em Visitas"
                reportServiceFunction={(payload, download) =>
                  reportService.fetchVisitsAmount(
                    { ...payload, eventType: 1 },
                    download
                  )
                }
              />
            }
          />
          <Route
            path="/speedcontrol"
            element={
              <ReportPage
                pageGrid={"gridSpeedControl"}
                pageTitle="Controle de Velocidade"
                reportServiceFunction={reportService.fetchSpeedControl}
              />
            }
          />
          <Route path="/protocols" element={<ProtocolsPage />} />
          <Route path="/protocol-summary" element={<ProtocolSummaryPage />} />
          <Route path="/alerts" element={<AlertsPage />} />
          <Route
            path="/systemlogs"
            element={
              <ReportPage
                pageGrid={"gridSystemLogs"}
                pageTitle="Logs"
                reportServiceFunction={reportService.fetchSystemLogs}
              />
            }
          />
          <Route
            path="/detailedvehicleactivity"
            element={<WorkingInProgress />}
          />

          <Route
            path="*"
            element={
              <div style={{ padding: "10%" }}>
                <h1>404 - Rota ou página não encontrada</h1>
              </div>
            }
          />
          <Route path="workinginprogress" element={<WorkingInProgress />} />
        </Route>
        <Route
          path="viewmap/:groupfilter/:vehiclefilter/:showVisits"
          element={<ViewMap />}
        />
      </Routes>
    </HashRouter>
  );
}

function RequireAuthAndDomain({ children }) {
  let auth = authService.authenticated();
  let location = useLocation();
  if (!auth) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}
